import { render, staticRenderFns } from "./ReportModalButton.vue?vue&type=template&id=f70384d0&scoped=true&"
import script from "./ReportModalButton.vue?vue&type=script&lang=js&"
export * from "./ReportModalButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70384d0",
  null
  
)

export default component.exports